import { NibbleCut } from '@aipb/personal-content/shared/model';
import { saveFileFromUrl } from '@aipb/util/other';
import { UseCase } from '@aipb/util/usecase';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DownloadUseCase implements UseCase<NibbleCut> {
  execute(data: NibbleCut): void {
    const url = data.nibble.userThumb;
    saveFileFromUrl(url);
  }
}
